import React from "react";
import PropTypes from "prop-types";

import Sidebar from "components/Sidebar";

import { useFeedFilters, useReminders } from "./hooks";
import { FeedContent, FeedSettings, ReminderStats } from "./components";

export function HubFeed({ hidden }) {
  const [currentFilters, setFilters, setToDefault] = useFeedFilters();
  const [counts, reminders] = useReminders(currentFilters);

  return (
    <Sidebar
      title="Hub Feed"
      slideAway={hidden}
      tab={<ReminderStats {...counts} />}
      onOpening={reminders.fetch}
      onOpened={reminders.setShown}
      onClosed={reminders.setNotShown}
    >
      <FeedSettings
        filters={currentFilters}
        onChange={setFilters}
        onClear={setToDefault}
      />
      <FeedContent reminders={reminders} />
    </Sidebar>
  );
}

HubFeed.propTypes = {
  hidden: PropTypes.bool,
};

HubFeed.defaultProps = {
  hidden: false,
};

export default HubFeed;
